// extracted by mini-css-extract-plugin
export default {"dash_grid":"DashboardGrid_dash_grid__RPJrA"};